<template>
  <div
    v-if="visibleNewsItems.length > 0"
    class="wrapper"
  >
    <section-heading
      v-if="title"
      :heading-color="headingColor"
      :heading-color-hex="headingColorHex"
      :heading-font-size="headingFontSize"
      :heading-align="headingAlign"
      :heading-type="headingType"
      :heading-background-image-url="headingBackgroundImageUrl"
      :heading-background-image-repeat="headingBackgroundImageRepeat"
      :title="title"
      :for-mobile-view="isMobileView"
      class="container q-pb-sm"
    />
    <swiper
      ref="newsCarouselSwiper"
      :key="newsCarouselType"
      :modules="[Navigation, Pagination, Autoplay]"
      :navigation="{
        nextEl: `.swiper-button-next-${id}`,
        prevEl: `.swiper-button-prev-${id}`
      }"
      :pagination="{
        el: `.swiper-pagination-${id}`,
        type: 'bullets',
        clickable: true
      }"
      :autoplay="autoplayOptions"
      :slides-per-view="slidesPerRow"
      :space-between="spaceBetween"
      :breakpoints="breakpoints"
      :centered-slides="newsCarouselType === CAROUSEL_TYPES.CAROUSEL"
      :loop="isLoop"
      preload-images
      class="swiper"
      :style="{
        'height': newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? '50vw': undefined,
        'max-height': newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? isPhonePreview ? '360px' : '500px' : undefined,
        'padding-bottom': paginationVisible ? '40px' : undefined,
        'min-height': (newsCarouselType === CAROUSEL_TYPES.CAROUSEL && isMobileView) ? '360px' : undefined
      }"
    >
      <swiper-slide
        v-for="newsItem in visibleNewsItems"
        v-slot="{ isActive }"
        :key="newsItem.id"
        :class="{
          [`shadow-${shadow}`]: newsCarouselType === CAROUSEL_TYPES.SLIDER,
          [`bg-${backgroundColor}`]: backgroundColor !== 'custom' && backgroundColor !== null,
          'cursor-pointer': newsItem.hasAction
        }"
        :style="{
          'background-color': backgroundColor === 'custom'
            ? backgroundColorHex
            : backgroundColor === null
              ? '#000000'
              : undefined,
          'border-radius': newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? undefined : `${borderRadius}px`,
          'padding-top': textPosition ===TEXT_POSITION_TYPES.TOP && isMobileView ? '140px' : undefined
        }"
        style="height: auto"
        @click="clickSlideHandler(newsItem)"
      >
        <div style="height:100%">
          <div
            class="row justify-center relative-position"
          >
            <img
              :class="{ 'col': !keepImageRatio }"
              :style="{
                opacity: !isActive && newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? '0.8' : undefined,
                filter: !isActive && newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? 'brightness(0.5)' : undefined,
                width: keepImageRatio ? '100%' : undefined,
                height: keepImageRatio && newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? '50vw' : undefined,
                'margin': hasPartialSlides && textPosition ===TEXT_POSITION_TYPES.FULL && !isMobileView ? '0 8%' : undefined,
                'object-fit': keepImageRatio && newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? 'contain' : undefined,
                'max-height': keepImageRatio && newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? '500px' : undefined,
                'max-width': !keepImageRatio && newsCarouselType === CAROUSEL_TYPES.CAROUSEL ? $getMaxWidthForScreenSize(): undefined
              }"
              :alt="newsItem.title"
              :src="keepImageRatio ? newsItem.imageUrlOriginalRatio : newsItem.imageUrl"
            >
          </div>

          <template v-if="showItemButton || showItemTitle || showItemSubtitle || showItemDescription || showItemDate || showItemClass">
            <template v-if="newsCarouselType === CAROUSEL_TYPES.CAROUSEL">
              <div
                v-if="showItemButton || showItemTitle || showItemSubtitle"
                class=" flex justify-center q-py-xs"
                :class="{
                  'absolute-top': textPosition ===TEXT_POSITION_TYPES.TOP,
                  'absolute-bottom': textPosition ===TEXT_POSITION_TYPES.BOTTOM,
                  'absolute-full': textPosition ===TEXT_POSITION_TYPES.FULL,
                  'message-container': textPosition !==TEXT_POSITION_TYPES.FULL
                }"
                :style="{
                  background: textPosition ===TEXT_POSITION_TYPES.FULL ? gradientBackgroundColor : undefined,
                  'min-height': textPosition ===TEXT_POSITION_TYPES.BOTTOM && isMobileView ? '160px' : undefined
                }"
              >
                <div
                  v-if="isActive"
                  class="items-center full-width"
                  :class="{
                    'row q-gutter-sm': textPosition !==TEXT_POSITION_TYPES.FULL && !isMobileView,
                    'justify-around q-py-sm': textPosition !==TEXT_POSITION_TYPES.FULL,
                    'self-center': textPosition ===TEXT_POSITION_TYPES.FULL,
                    'q-px-xl': controlsVisible,
                    'q-px-md': !controlsVisible,
                    'q-gutter-sm': textPosition ===TEXT_POSITION_TYPES.FULL
                  }"
                  :style="{ 'max-width': $getMaxWidthForScreenSize() }"
                  style="min-height: 80px;"
                >
                  <div
                    class="items-start"
                    :class="{
                      'col items-center': textPosition !==TEXT_POSITION_TYPES.FULL,
                      'row': (showItemDate && getRelativeNewsDate(newsItem)) || (showItemClass && getNewItemsClassName(newsItem))
                    }"
                  >
                    <div
                      v-if="(showItemDate && getRelativeNewsDate(newsItem)) || (showItemClass && getNewItemsClassName(newsItem))"
                      class="item-date col-auto full-height justify-center items-center q-mr-md"
                      :class="{
                        'column': !isMobileView,
                        'q-mb-md': isMobileView,
                        'bg-primary': !newsItem.color,
                        [getTextColorClass(newsItem)]: true
                      }"
                      :style="{
                        'background-color': newsItem.color,
                        'min-height': !isMobileView ? '80px' : undefined
                      }"
                    >
                      <div
                        v-if="showItemDate && getRelativeNewsDate(newsItem)"
                        class="text-h6 text-center"
                        :class="{
                          'column': !isMobileView,
                          'q-px-md': showItemClass && getNewItemsClassName(newsItem),
                          'q-pt-md': showItemClass && getNewItemsClassName(newsItem) && !isMobileView,
                          'q-px-md q-pt-sm': !showItemClass || !getNewItemsClassName(newsItem),
                          [getTextColorClass(newsItem)]: true
                        }"
                        style="line-height: 1.2rem;"
                        :style="{ display: isMobileView ? 'inline-block' : undefined }"
                      >
                        {{ formatDate(getRelativeNewsDate(newsItem), 'MMM') }}

                        <span
                          :class="{ 'text-h4': !isMobileView }"
                        >
                          {{ formatDate(getRelativeNewsDate(newsItem), 'D') }}
                        </span>
                      </div>
                      <span
                        v-if="showItemClass && getNewItemsClassName(newsItem)"
                        class="q-px-md"
                        style="z-index: 2"
                        :class="{
                          'text-h6': isMobileView || (!showItemDate || !getRelativeNewsDate(newsItem)),
                          'text-subtitle2': showItemDate && getRelativeNewsDate(newsItem) && !isMobileView,
                          'q-pb-sm q-mt-xs': showItemDate && getRelativeNewsDate(newsItem),
                          'text-white': $isColorDark(currentSite.primaryColor),
                          'text-dark': !$isColorDark(currentSite.primaryColor)
                        }"
                      >
                        {{ getNewItemsClassName(newsItem) }}
                      </span>
                    </div>
                    <div
                      :style="textPosition ===TEXT_POSITION_TYPES.FULL && !isMobileView ? 'max-width: 50%' : undefined"
                      :class="{ 'col': !isMobileView }"
                    >
                      <div
                        v-if="showItemTitle"
                        class="title text-h6 text-white"
                        :style="{ 'font-size': textPosition ===TEXT_POSITION_TYPES.FULL ? '40px' : '24px' }"
                      >
                        {{ newsItem.title }}
                      </div>
                      <div
                        v-if="showItemSubtitle && !!newsItem.subtitle"
                        class="subtitle ellipsis text-white"
                        :class="{ 'q-px-md q-mt-xs': newsItem.color }"
                        :style="{
                          'background-color': newsItem.color,
                          'display': newsItem.color ? 'inline-block' : undefined,
                          'font-size': isMobileView ? '14px' : '16px'
                        }"
                      >
                        {{ newsItem.subtitle }}
                      </div>
                      <div
                        v-if="showItemDescription && !!newsItem.description"
                        class="subtitle text-white"
                        :class="{
                          'ellipsis': textPosition !==TEXT_POSITION_TYPES.FULL && isMobileView,
                          'ellipsis-3-lines': textPosition ===TEXT_POSITION_TYPES.FULL || isMobileView,
                          'q-mb-sm': isMobileView
                        }"
                        :style="{ 'font-size': isMobileView ? '14px' : '16px' }"
                      >
                        {{ newsItem.description }}
                      </div>
                    </div>
                  </div>

                  <q-btn
                    v-if="showItemButton && newsItem.hasAction && !!newsItem.buttonText"
                    class="col-auto"
                    :class="textPosition ===TEXT_POSITION_TYPES.FULL ? 'q-my-md' : undefined"
                    :outline="buttonType === BUTTON_TYPES.OUTLINE"
                    :flat="buttonType === BUTTON_TYPES.FLAT"
                    :unelevated="buttonType === BUTTON_TYPES.UNELEVATED"
                    :color="buttonColor !== 'custom' ? buttonColor : undefined"
                    :style="{
                      'background-color': ((buttonType === BUTTON_TYPES.STANDARD || buttonType === BUTTON_TYPES.UNELEVATED) && buttonColor === 'custom') ? buttonColorHex : undefined,
                      'border-radius': `${buttonBorderRadius}px`,
                      'color': ((buttonType === BUTTON_TYPES.FLAT || buttonType === BUTTON_TYPES.OUTLINE) && buttonColor === 'custom') ? buttonColorHex : undefined
                    }"
                    :text-color="((buttonType === BUTTON_TYPES.STANDARD || buttonType === BUTTON_TYPES.UNELEVATED) && buttonColor === 'custom' && buttonColorHex === '#ffffff') ? 'primary' : 'white'"
                    style="width: auto; height: 50px"
                    align="left"
                  >
                    {{ newsItem.buttonText }}
                  </q-btn>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row">
                <div
                  v-if="(showItemDate && getRelativeNewsDate(newsItem)) || (showItemClass && getNewItemsClassName(newsItem))"
                  class="item-date col-auto full-height justify-center items-center"
                  :class="{
                    'column': hasTitleOrDescriptionOrButtonShow(newsItem),
                    'bg-primary': !newsItem.color,
                    [getTextColorClass(newsItem)]: true
                  }"
                  :style="{
                    'background-color': newsItem.color,
                    'min-height': hasTitleOrDescriptionOrButtonShow(newsItem)? '100px' : undefined
                  }"
                >
                  <span
                    v-if="showItemClass && getNewItemsClassName(newsItem)"
                    class="q-px-md"
                    style="z-index: 2"
                    :class="{
                      'text-h6': !showItemDate || !getRelativeNewsDate(newsItem) || !hasTitleOrDescriptionOrButtonShow(newsItem),
                      'text-subtitle2': showItemDate && getRelativeNewsDate(newsItem) && hasTitleOrDescriptionOrButtonShow(newsItem),
                      'q-pt-md': showItemDate && getRelativeNewsDate(newsItem),
                      [getTextColorClass(newsItem)]: true
                    }"
                  >
                    {{ getNewItemsClassName(newsItem) }}
                  </span>
                  <div
                    v-if="showItemDate && getRelativeNewsDate(newsItem)"
                    class="text-h6 text-center"
                    :class="{
                      'column': hasTitleOrDescriptionOrButtonShow(newsItem),
                      'q-px-md q-pt-sm q-pb-md': showItemClass && getNewItemsClassName(newsItem),
                      'q-pa-md': !(showItemClass && getNewItemsClassName(newsItem)),
                      [getTextColorClass(newsItem)]: true
                    }"
                    style="line-height: 1.2rem;"
                    :style="{ display: !hasTitleOrDescriptionOrButtonShow(newsItem) ? 'inline-block' : undefined }"
                  >
                    {{ formatDate(getRelativeNewsDate(newsItem), 'MMM') }}
                    <span
                      :class="{ 'text-h3': hasTitleOrDescriptionOrButtonShow(newsItem) }"
                    >
                      {{ formatDate(getRelativeNewsDate(newsItem), 'D') }}
                    </span>
                    {{ formatDate(getRelativeNewsDate(newsItem), 'YYYY') }}
                  </div>
                </div>
                <div class="col">
                  <div
                    v-if="showItemSubtitle && !!newsItem.subtitle"
                    class="q-py-xs text-uppercase text-bold inset-shadow"
                    :class="{
                      'text-dark': newsItem.color ? !$isColorDark(newsItem.color) : !textLight,
                      'text-white': newsItem.color ? $isColorDark(newsItem.color) : textLight,
                      'text-center': textCentred || !((showItemDate && getRelativeNewsDate(newsItem)) || (showItemClass && getNewItemsClassName(newsItem))),
                      'q-pl-md': !textCentred && ((showItemDate && getRelativeNewsDate(newsItem)) || (showItemClass && getNewItemsClassName(newsItem)))
                    }"
                    :style="{
                      'background-color': newsItem.color,
                      'border-bottom-left-radius': showItemDate || showItemClass ? undefined : `${borderRadius}px` ,
                      'border-bottom-right-radius': showItemDate || showItemClass ? undefined : `${borderRadius}px`
                    }"
                  >
                    {{ newsItem.subtitle }}
                  </div>
                  <div class="q-pa-md">
                    <div
                      v-if="showItemTitle && !!newsItem.title"
                      class="text-h5"
                      :class="{
                        'text-white': textLight,
                        'text-center': textCentred
                      }"
                    >
                      {{ newsItem.title }}
                    </div>
                    <div
                      v-if="showItemDescription && !!newsItem.description"
                      class="ellipsis-3-lines"
                      :class="{
                        'text-white': textLight,
                        'text-center': textCentred
                      }"
                    >
                      {{ newsItem.description }}
                    </div>

                    <div
                      v-if="showItemButton && newsItem.hasAction && !!newsItem.buttonText"
                      :class="{ 'text-center': textCentred }"
                      class="q-mt-sm q-mb-md"
                    >
                      <q-btn
                        flat
                        padding="sm none"
                        :ripple="false"
                        class="btn-link btn--no-hover"
                        :class="textLight ? 'text-white' : 'text-secondary'"
                      >
                        {{ newsItem.buttonText }}
                      </q-btn>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </swiper-slide>
      <div
        v-if="paginationVisible"
        class="swiper-pagination text-primary"
        style="margin-bottom: 0px;"
        :class="'swiper-pagination-' + id"
      />
      <div
        v-if="controlsVisible"
        class="swiper-button-prev bg-primary shadow-5"
        :style="{
          'margin-left': widthMode === 'Full Width' ? '-5px' : '-10px',
          'top': newsCarouselType === CAROUSEL_TYPES.SLIDER ? '30%' : undefined
        }"
        :class="{
          'text-white': $isColorDark(currentSite.primaryColor),
          'text-dark': !$isColorDark(currentSite.primaryColor),
          [`swiper-button-prev-${id}`]: controlsVisible
        }"
      />
      <div
        v-if="controlsVisible"
        :id="`swiper-button-next-${id}`"
        class="swiper-button-next bg-primary shadow-5"
        :style="{
          'margin-right': widthMode === 'Full Width' ? '-5px' : '-10px',
          'top': newsCarouselType === CAROUSEL_TYPES.SLIDER ? '30%' : undefined
        }"
        :class="{
          'text-white': $isColorDark(currentSite.primaryColor),
          'text-dark': !$isColorDark(currentSite.primaryColor),
          [`swiper-button-next-${id}`]: controlsVisible
        }"
      />
    </swiper>
    <q-menu
      v-if="currentUser && currentUser.admin"
      touch-position
      context-menu
    >
      <q-list style="width: 200px;">
        <q-item
          v-close-popup
          clickable
          @click="editNewsItems = true"
        >
          <q-item-section avatar>
            <q-icon name="edit" />
          </q-item-section>
          <q-item-section>
            Edit News Items
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
    <q-dialog
      v-model="editNewsItems"
      full-width
    >
      <news-item-table />
    </q-dialog>
  </div>
</template>

<script>
import { date } from 'quasar'
import { CAROUSEL_TYPES, TEXT_POSITION_TYPES } from 'src/models/carousel/Carousel'
import { BUTTON_TYPES, DISPLAY_DATE_TYPES } from 'src/models/page/Section'
import SectionHeading from 'src/modules/consumer/components/SectionHeading'
const { formatDate } = date
import SwiperModulesMixin from 'src/modules/consumer/components/mixins/SwiperModulesMixin'
import { defineAsyncComponent } from 'vue'
export default {
  name: 'NewsCarousel',
  context: ['currentUser'],
  configuration: ['newsItemClasses', 'currentSite'],
  components: {
    NewsItemTable: defineAsyncComponent(() => import('src/modules/admin/news-item/NewsItemTable')),
    SectionHeading
  },
  mixins: [SwiperModulesMixin],
  props: {
    id: {
      type: Number,
      required: false,
      default: 0
    },
    newsItems: {
      type: Array,
      required: true
    },
    newsItemClassIds: {
      type: Array,
      required: false,
      default: () => ([])
    },
    admin: {
      type: Boolean,
      required: false,
      default: false
    },
    delayInSeconds: {
      type: Number,
      required: false,
      default: 6
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true
    },
    newsCarouselType: {
      type: String,
      required: false,
      default: CAROUSEL_TYPES.CAROUSEL
    },
    controlsVisible: {
      type: Boolean,
      required: false,
      default: false
    },
    paginationVisible: {
      type: Boolean,
      required: false,
      default: false
    },
    showItemTitle: {
      type: Boolean,
      required: false,
      default: true
    },
    showItemSubtitle: {
      type: Boolean,
      required: false,
      default: false
    },
    showItemDescription: {
      type: Boolean,
      required: false,
      default: true
    },
    showItemButton: {
      type: Boolean,
      required: false,
      default: true
    },
    showItemClass: {
      type: Boolean,
      required: false,
      default: false
    },
    showItemDate: {
      type: Boolean,
      required: false,
      default: false
    },
    dateType: {
      type: String,
      required: false,
      default: DISPLAY_DATE_TYPES.PUBLISHED
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'custom'
    },
    backgroundColorHex: {
      type: String,
      required: false,
      default: '#000000'
    },
    slidesPerView: {
      type: Number,
      required: false,
      default: 3
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 3
    },
    sliderGutter: {
      type: Number,
      required: false,
      default: 15
    },
    sliderAllowLoop: {
      type: Boolean,
      required: false,
      default: true
    },
    sliderPaginateGroupedSlides: {
      type: Boolean,
      required: false,
      default: false
    },
    shadow: {
      type: Number,
      required: false,
      default: 0
    },
    textCentred: {
      type: Boolean,
      required: false,
      default: true
    },
    textLight: {
      type: Boolean,
      required: false,
      default: true
    },
    buttonType: {
      type: String,
      required: false,
      default: BUTTON_TYPES.OUTLINE
    },
    buttonColor: {
      type: String,
      required: false,
      default: 'custom'
    },
    buttonColorHex: {
      type: String,
      required: false,
      default: '#FFFFFF'
    },
    buttonBorderRadius: {
      type: Number,
      required: false,
      default: 0
    },
    textPosition: {
      type: String,
      required: false,
      default: TEXT_POSITION_TYPES.BOTTOM
    },
    hasPartialSlides: {
      type: Boolean,
      required: false,
      default: false
    },
    widthMode: {
      type: String,
      required: false,
      default: 'Centered'
    },
    keepImageRatio: {
      type: Boolean,
      required: false,
      default: false
    },
    isPhonePreview: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobileView: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    headingColor: {
      type: String,
      default: 'primary',
      required: false
    },
    headingColorHex: {
      type: String,
      default: '#FFFFFF',
      required: false
    },
    headingAlign: {
      type: String,
      default: null,
      required: false
    },
    headingFontSize: {
      type: String,
      default: null,
      required: false
    },
    headingType: {
      type: String,
      default: 'default',
      required: false
    },
    headingBackgroundImageUrl: {
      type: String,
      default: null,
      required: false
    },
    headingBackgroundImageRepeat: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      editNewsItems: false
    }
  },
  computed: {
    visibleNewsItems () {
      return _.filter(this.newsItems, newsItem => {
        return newsItem.visible && (!this.newsItemClassIds.length || _.includes(this.newsItemClassIds, newsItem.newsItemClassId))
      })
    },
    breakPoints () {
      if (this.sliderPaginateGroupedSlides) {
        return {
          300: { slidesPerView: 1, slidesPerGroup: 1 },
          640: { slidesPerView: 1, slidesPerGroup: 1 },
          768: { slidesPerView: 2, slidesPerGroup: 2 },
          1024: { slidesPerView: this.slidesPerView, slidesPerGroup: this.slidesPerView }
        }
      } else {
        return {
          300: { slidesPerView: 1 },
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: this.slidesPerView }
        }
      }
    },
    carouselBreakPoints () {
      return {
        300: { slidesPerView: 1 },
        1280: { slidesPerView: 1.2 },
        1440: { slidesPerView: 1.3 },
        1680: { slidesPerView: 1.4 }
      }
    },
    slidesPerRow () {
      if (!this.newsCarouselType) return
      if (this.newsCarouselType === CAROUSEL_TYPES.SLIDER) {
        return this.isPhonePreview ? 1 : this.slidesPerView
      } else {
        return 1
      }
    },
    spaceBetween () {
      if (!this.newsCarouselType) return
      return this.newsCarouselType === CAROUSEL_TYPES.SLIDER ? this.sliderGutter : undefined
    },
    breakpoints () {
      if (!this.newsCarouselType) return
      if (this.newsCarouselType === CAROUSEL_TYPES.SLIDER) {
        return this.isPhonePreview ? undefined : this.breakPoints
      } else {
        return (this.hasPartialSlides && this.widthMode === 'Full Width' && !this.isPhonePreview) ? this.carouselBreakPoints : undefined
      }
    },
    isLoop () {
      if (this.newsCarouselType === CAROUSEL_TYPES.SLIDER) {
        return this.sliderAllowLoop
      } else {
        return this.newsItems.length !== 1
      }
    },
    gradientBackgroundColor () {
      if (this.backgroundColor === null) return 'linear-gradient(to right, #000000, transparent 50%)'
      if (this.backgroundColor === 'custom') return 'linear-gradient(to right, ' + this.backgroundColorHex + ', transparent 50%)'
      return 'linear-gradient(to right, var(--q-' + this.backgroundColor + '), transparent 50%)'
    }
  },
  created () {
    _.extend(this, { formatDate, CAROUSEL_TYPES, DISPLAY_DATE_TYPES, BUTTON_TYPES, TEXT_POSITION_TYPES })
  },
  methods: {
    clickSlideHandler (newsItem) {
      if (!newsItem || !newsItem.hasAction) return

      this.$trackEvent(this.$customerEvents.CLICKED_HERO, { id: newsItem.id, title: newsItem.title })

      newsItem.route(this.$router)
    },
    getRelativeNewsDate (newsItem) {
      if (this.dateType === DISPLAY_DATE_TYPES.PUBLISHED && newsItem.publishedAt) return newsItem.publishedAt.i18n('date')
      if (this.dateType === DISPLAY_DATE_TYPES.START && newsItem.startDate) return newsItem.startDate.i18n('date')
      if (this.dateType === DISPLAY_DATE_TYPES.END && newsItem.endDate) return newsItem.endDate.i18n('date')
    },
    hasTitleOrDescriptionOrButtonShow (newsItem) {
      return (this.showItemTitle && !!newsItem.title) || (this.showItemDescription && !!newsItem.description) || (this.showItemButton && newsItem.hasAction && !!newsItem.buttonText)
    },
    getNewItemsClassName (newsItem) {
      const getNewItemsClassName = {}
      _.each(this.newsItemClasses.data, newsItemClass => {
        getNewItemsClassName[newsItemClass.id] = newsItemClass.name
      })
      return getNewItemsClassName[newsItem.newsItemClassId]
    },
    getTextColorClass (newsItem) {
      const hasCustomColor = !!newsItem.color
      const effectiveColor = hasCustomColor ? newsItem.color : this.currentSite.primaryColor
      return this.$isColorDark(effectiveColor) ? 'text-white' : 'text-dark'
    }
  }
}
</script>

<style lang="scss" scoped>
  .message-container {
    background-color: rgba(0, 0, 0, 0.5)
  }
</style>
